import type { SettingState } from '../types';

// ofuro-wiki: No AI feature
export const AIUsagePanel = (_props: {
  onChangeSettingState?: (settingState: SettingState) => void;
}) => {
  return null;
};
